import { Dialog, DialogActions } from '@mui/material';
import React from 'react';

import CustomButton from '../../../../../../../lib/designSystem/Button';
import { cellFormat } from '../../../../../../../lib/designSystem/Table/cellFormat';
import EnhancedTab from '../../../../../../../lib/designSystem/TabSimulation';
import PayOutDetailAppliedDocuments from './components/AppliedDocuments';
import PaymentRequestApprovals from './components/Approvals';
import PayOutDetailPayouts from './components/Payouts';
import PayOutDetaiPendingAccounts from './components/PendingAccounts';
import PayOutSummary from './components/Summary';

const tabsBySource = (
  request: any,
  setSuccess: any,
  setFailure: any,
  setUp: () => Promise<void>,
  reset: any,
) => {
  const summary = {
    index: 0,
    label: 'Resumen',
    component: <PayOutSummary request={request} />,
  };

  const payments = {
    index: 0,
    label: 'Pagos',
    disabled: request.status === 'En revisión' || request.amount === 0,
    component: (
      <PayOutDetailPayouts
        request={request}
        payments={request.payments}
        sourceId={request.sourceId}
        source={request.source}
        setSuccess={setSuccess}
        setFailure={setFailure}
        reset={setUp}
      />
    ),
  };

  const appliedDocuments = {
    index: 1,
    label: 'Documentos Aplicados',
    component: (
      <PayOutDetailAppliedDocuments
        documentsApplied={request.documentsApplied}
        source={request.source}
        sourceId={request.sourceId}
        setSuccess={setSuccess}
        setFailure={setFailure}
        reset={reset}
      />
    ),
  };

  const pendingAccouns = {
    index: 3,
    label: 'Cuentas pendientes',
    component: (
      <PayOutDetaiPendingAccounts
        pendingAccounts={request.pendingAccounts}
        source={request.source}
        sourceId={request.sourceId}
        setSuccess={setSuccess}
        setFailure={setFailure}
        reset={reset}
      />
    ),
  };

  const approvals = {
    index: 4,
    label: 'Aprobaciones',
    component: (
      <PaymentRequestApprovals request={request} refreshRequest={setUp} />
    ),
  };

  return [summary, pendingAccouns, appliedDocuments, payments, approvals];
};

const PayOutDetails = (props: any) => {
  const {
    paymentGroupedDetails,
    open,
    setOpen,
    setSuccess,
    setFailure,
    setUp,
  } = props;
  const startValue = 0;

  const reset = async () => {
    await setUp();
    setOpen(false);
  };

  const tabs = tabsBySource(
    paymentGroupedDetails,
    setSuccess,
    setFailure,
    setUp,
    reset,
  );

  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={() => setOpen(false)}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={`${paymentGroupedDetails.sourceTranslation} ${cellFormat(paymentGroupedDetails.sourceId, 'numeric-id')} `}
          startValue={startValue}
          tabs={tabs}
        />
      </div>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          {' '}
          Salir{' '}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default PayOutDetails;
